import { BadgeVariant } from "shared/components";
import { NewBadge } from "shared/app/NewBadge";
import { cx } from "shared/utils";
import { ResolvedNavSection } from "../nav-settings";

const sectionHeaderClassName = "mb-2 ml-3 text-xs font-medium text-content-200";

const sectionHeaderWithBadgeClassName =
  "mb-2 ml-3 items-center gap-2 text-xs font-medium text-content-200";

export const NavSectionHeader = ({
  section,
  isAlwaysVisible = false
}: {
  section: ResolvedNavSection;
  isAlwaysVisible?: boolean;
}) => {
  if (!section.title) return null;

  return section.isNew ? (
    <div
      className={cx(
        sectionHeaderWithBadgeClassName,
        isAlwaysVisible ? "flex" : "hidden md:group-hover:flex"
      )}
    >
      <p>{section.title}</p>
      <NewBadge variant={BadgeVariant.BASE} />
    </div>
  ) : (
    <p
      className={cx(
        sectionHeaderClassName,
        isAlwaysVisible ? "block" : "hidden md:group-hover:block"
      )}
    >
      {section.title}
    </p>
  );
};
